import { render, staticRenderFns } from "./AppLunbo.vue?vue&type=template&id=bade9704&scoped=true&"
import script from "./AppLunbo.vue?vue&type=script&lang=js&"
export * from "./AppLunbo.vue?vue&type=script&lang=js&"
import style0 from "./AppLunbo.vue?vue&type=style&index=0&id=bade9704&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bade9704",
  null
  
)

export default component.exports